import { Space } from "antd";
import { routes } from "config/routes";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import RemoveButton from "../components/RemoveButton";
import { FaEye } from "react-icons/fa6";
import TooltipButton from "views/Documents/components/TooltipButton";

export default function useClientsTableColumns(
  refetch: () => void,
): (Record<any, any> | boolean)[] {
  const { t } = useTranslation();
  const { companyId } = useParams();

  return [
    {
      title: t("Code"),
      dataIndex: "code",
      key: "code",
      sorter: true,
      filterType: {
        type: "SearchFilter",
        varName: "code_Icontains",
      },
    },
    {
      title: t("Name"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      filterType: {
        type: "SearchFilter",
        varName: "name_Icontains",
      },
    },
    {
      title: t("Siren"),
      dataIndex: "vatNumber",
      key: "vatNumber",
      filterType: {
        type: "SearchFilter",
        varName: "vatNumber_Startswith",
      },
    },
    {
      dataIndex: t("Action"),
      key: "action",
      title: "Action",
      align: "center",
      width: "100px",
      fixed: "right",
      render: (_text: unknown, record: Record<string, any>) => (
        <Space size="small" direction="horizontal" className="centered">
          <TooltipButton
            placement="top"
            handleOnClick={() =>
              routes.navigate(`/company/${companyId}/clients/${record.id}/client`)
            }
            icon={<FaEye />}
          />
          <RemoveButton id={record?.id} refetch={refetch} />
        </Space>
      ),
    },
  ];
}
